import React, { useEffect, useRef, useState } from 'react';
import useReveal from '../hooks/useReveal';

export function AnimatedCounter({ value, prefix = '', suffix = '', duration = 1800 }) {
  const [ref, inView] = useReveal();
  const [count, setCount] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    if (inView && !started.current) {
      started.current = true;
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        setCount(Math.round(eased * value));
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
  }, [inView, value, duration]);

  return <span ref={ref}>{prefix}{count.toLocaleString('it-IT')}{suffix}</span>;
}

export function SectionHeading({ label, title, highlight, center = false, light = false }) {
  return (
    <div className={`max-w-3xl ${center ? 'mx-auto text-center' : ''}`}>
      {label && <p className="mono-label mb-4">_{label}</p>}
      <h2 className={`font-display font-bold text-3xl md:text-5xl leading-[1.08] ${light ? 'text-background' : 'text-white'}`}>
        {title} {highlight && <span className="gradient-text">{highlight}</span>}
      </h2>
    </div>
  );
}

export function Marquee({ items, className = '', speed = 'animate-marquee' }) {
  return (
    <div className="relative overflow-hidden w-full">
      <div className={`flex gap-4 w-max ${speed} ${className}`}>
        {[...items, ...items].map((item, i) => (
          <span key={i} className="whitespace-nowrap">{item}</span>
        ))}
      </div>
    </div>
  );
}
